import React, { useState } from "react";
import { Form , DatePicker, Button , Row, Col ,Typography , Table ,Radio , Tooltip } from 'antd';
import { loadingAction } from './../../actions/loading-actions';
import { useDispatch } from "react-redux";
import { fetchBookingSheet } from './../../actions/reports.action';
import { Printer } from './../../components/custom-components/custom-component';
import { insertAtPosition, isValidArray, isValidNumber, removeArrayIndexValue } from "../../utils/utilities";
import { getAPIDateFormat  , getLocalDateAndTime , getLocalDate , convertDateStringToDate, getCurrentDateInIST, isDateInRange, decrementDays, incrementDays} from './../../utils/date.utils';
import { subtractFloatingPoints as SFP , addFloatingPoints as AFP, roundNumber, getValueFromPercentage } from './../../utils/math.utils';
import { isValid } from "../../utils/utilities";
import { getRangeOptions , getPaginationDetails, getDefaultPageSize} from './reports.module';
import * as XLSX from 'xlsx';
import { InfoCircleOutlined } from '@ant-design/icons';
import { DAFIDY_USER, PREPAID_OTA_USER } from "../../utils/constant";
import { isOtaPartnerUser } from "../../utils/ota-partner.util";

const verifyOTAOrDafidyUser = ()=>{
    if(global.operatorCode == "DAFIDY"){
        return true;
    }else{
        return false;
    }
}

const onlyForMaven = ()=>{
    // Legacy maven check (kept until the ota_partner registry is proven in
    // production); any registered OTA partner agent gets the same treatment.
    if(global.operatorCode == "Dafidy"&&global.privilege == "PrePaid-OTA"){
        return true;
    }else if(isOtaPartnerUser()){
        return true;
    }else{
        return false;
    }
}

const getColsForDiscountedTickets=(confimColumns)=>{
    let cols = [...confimColumns];
    const fareColIndex = cols.findIndex(c => c.key === 'fare' && c.title === "Ticket Fare(A)");
    if (fareColIndex === -1) return cols;
    removeArrayIndexValue(cols, fareColIndex);
    insertAtPosition(cols, fareColIndex, {
        title:"Fare",
        key:"fare",
        dataIndex:"fare",
        render : (text, record, index) => {
            if(record.traveller_status == "Confirmed"){
                return text;
            }
            return null;
        }
    });
    insertAtPosition(cols, fareColIndex + 1, {
        title:"Discounted Fare (A)",
        key:"discounted_fare",
        dataIndex:"discounted_fare",
        render : (text, record, index) => {
            if(record.traveller_status == "Confirmed"){
                return text;
            }
            return null;
        }
    });
    return cols;
}

const getConfirmData=(confirmedTickets)=>{
    let confirmData = [],discountData=[];
    let summaryTotalAmount = 0,summaryTotalComm = 0,summaryQwikBusComm = 0;
    let netAmountDebited = 0, summaryFare = 0, summaryTds = 0, summaryNetComm = 0;
    for (let index = 0; index < confirmedTickets.length; index++) {
        const element = confirmedTickets[index];
        let {amount_paid , commission,comm_for_qwikbus,fare,discounted_fare,tds_on_commission,net_commission} = element;
        if([PREPAID_OTA_USER,DAFIDY_USER].includes(global.privilege)&&element.fare - element.discounted_fare > 0){
            discountData.push(element);
        }else{
            confirmData.push(element);
            if(isValidNumber(amount_paid)){
                summaryTotalAmount = summaryTotalAmount + amount_paid;
                netAmountDebited = netAmountDebited+discounted_fare-commission;
            }
            if(isValidNumber(commission)){
                summaryTotalComm = summaryTotalComm + commission;
            }
            if(isValid(comm_for_qwikbus)){
                summaryQwikBusComm = comm_for_qwikbus + summaryQwikBusComm;
            }
            if(isValid(fare)){
                summaryFare = summaryFare + fare;
            }
            if(isValid(tds_on_commission)){
                summaryTds = summaryTds + tds_on_commission;
            }
            if(isValid(net_commission)){
                summaryNetComm = summaryNetComm + net_commission;
            }
        }
    }
    let confirmedSummaryData = {summaryTotalAmount,summaryTotalComm,summaryQwikBusComm, netAmountDebited, summaryFare, summaryTds, summaryNetComm}
    return {
        confirmData,discountData, confirmedSummaryData
    }
}

const getCancelledTicketSummary = (cancelledTicket, dateRange) => {
    let summaryTicketCost = 0, summaryCancellationPenality = 0, summaryOfRefund = 0, fareSummary = 0, cancellationPenalitySummary = 0;
    cancelledTicket.map((element) => {
        let {amount_paid , ticket_cost, commission,cancellation_penalty , cancellation_penality_percentage, fare,discounted_fare, booking_time} = element;
        if(isValidNumber(ticket_cost)){
            summaryTicketCost = summaryTicketCost + ticket_cost;
        }
        if(isValidNumber(fare)){
            fareSummary = fareSummary + fare;
        }
        if(isValidNumber(cancellation_penalty)){
            summaryCancellationPenality = summaryCancellationPenality + cancellation_penalty;
            let fareAmount = verifyOTAOrDafidyUser() ? (fare ?? discounted_fare) : amount_paid;
            summaryOfRefund = summaryOfRefund + fareAmount - cancellation_penalty;
        }
        if (isDateInRange(getAPIDateFormat(getCurrentDateInIST(booking_time)), getAPIDateFormat(decrementDays(dateRange[0],1)), getAPIDateFormat(incrementDays(dateRange[1],1)))) {
            cancellationPenalitySummary+=(cancellation_penalty*75)/100;
        }
        else {
            let agentPenality = getValueFromPercentage(cancellation_penalty,cancellation_penality_percentage);
            cancellationPenalitySummary+= (cancellation_penalty+commission-agentPenality-(discounted_fare ?? fare))
        }
    })
    return {
        summaryTicketCost, summaryCancellationPenality, summaryOfRefund, fareSummary, cancellationPenalitySummary
    }
}

const getNameByRecord=(text,record)=>{
    if(verifyOTAOrDafidyUser()){
        return record.operator_name;
    }else{
        return text;
    }
}

const getTitleByRecord=()=>{
    if(verifyOTAOrDafidyUser()){
        return "Operator name";
    }else{
        return "Agency";
    }
}

const getFareByRecord=(text,record)=>{
        return text;
}

const getAmountTitleByRecord=()=>{
    if(verifyOTAOrDafidyUser()){
        return "Fare";
    }else{
        return "Total Amount";
    }
}


const getSeatCountForExport = (element) => isValid(element.seat_number) ? String(element.seat_number).split(/[;,]/).filter(Boolean).length : '';

const generateJsonToExport=(form,confirmedTickets,cancelledTickets,confirmedDiscountedTickets)=>{

    let filters=form.getFieldsValue();
    let reportsConfirmedXmlData=[];
    let reportsCancelledXmlData=[];
    let reportDiscountXmlData=[];
    let agentName=filters.isSelectAllAgents?'all':filters.agentName;
    let dateType =filters.isBookingDate?"Booking":"Travel";
    let generatedTime = getLocalDateAndTime(new Date());

    const confirmedHeaders = [
        "PNR","Agent","Booking time","Seat number","Seat count","Name","Phone Number","Status",
        "Origin","Destination","Vehicle Number","Ticket Fare(A)","GST(B)","Total amount","Discount(D)","Amount Paid(A+B-D)",
        "Commission(F)","TDS(G)","Net commission(F-G)","Net amount","Travel date","Trip description","Cust GST Number","Rescheduled"
    ];
    if(onlyForMaven()){
        confirmedHeaders.push("Net Amount Deducted (A-B)");
    }

    const cancelledHeaders = [
        "PNR","Agent","Booking time","Seat number","Seat count","Name","Phone Number","Status",
        "Origin","Destination","Vehicle Number","Ticket Fare(A)","GST(B)","Total amount","Penality","Refund amount",
        "Travel date","Trip description","Cust GST Number"
    ];

    if(onlyForMaven()){
        cancelledHeaders.push("Net Amount Deducted");
    }

    if(isValidArray(confirmedTickets)&&confirmedTickets.length>0){
        confirmedTickets.forEach(element => {
            let startDate = '';
            let bookingTime = isValid(element.booking_time) ? getLocalDateAndTime(element.booking_time) : '';
            if(isValid(element.start_date)){
                startDate = getLocalDate(convertDateStringToDate(element.start_date.split('T')[0]));
            }
            let agentVal = getNameByRecord(element.name, element);
            let vehicleVal = element.vehicle_number ?? element.vechicle_no ?? '';
            let netAmount = element.traveller_status === "Confirmed" ? roundNumber(AFP(SFP(element.amount_paid, element.net_commission || 0), 0)) : '';
            reportsConfirmedXmlData.push([
                element.pnr,
                agentVal,
                bookingTime,
                element.seat_number ?? '',
                getSeatCountForExport(element),
                element.full_name ?? '',
                element.phone_number ?? '',
                element.traveller_status ?? '',
                element.origin ?? '',
                element.destination ?? '',
                vehicleVal,
                element.traveller_status === "Confirmed" ? roundNumber(element.fare) : '',
                element.traveller_status === "Confirmed" ? roundNumber(AFP(element.cgst || 0, element.sgst || 0)) : '',
                element.traveller_status === "Confirmed" ? roundNumber(element.ticket_cost) : '',
                element.traveller_status === "Confirmed" ? roundNumber(element.direct_discount ?? 0) : '',
                element.traveller_status === "Confirmed" ? roundNumber(element.amount_paid ?? 0) : '',
                element.traveller_status === "Confirmed" ? roundNumber(element.commission) : '',
                element.traveller_status === "Confirmed" ? roundNumber(element.tds_on_commission) : '',
                element.traveller_status === "Confirmed" ? roundNumber(element.net_commission) : '',
                netAmount,
                startDate,
                element.description ?? '',
                element.customer_gst_number ?? '',
                element.traveller_status === "Rescheduled" ? "Yes" : "No"
            ]);
            if(onlyForMaven()){
                reportsConfirmedXmlData[reportsConfirmedXmlData.length - 1].push(
                    element.traveller_status === "Confirmed" ? roundNumber((element.fare || 0) - (element.commission || 0)) : ''
                );
            }
        });
    }

    if(isValidArray(cancelledTickets)&&cancelledTickets.length>0){
        cancelledTickets.forEach(element => {
            let startDate = '';
            let bookingTime = isValid(element.booking_time) ? getLocalDateAndTime(element.booking_time) : '';
            if(isValid(element.start_date)){
                startDate = getLocalDate(convertDateStringToDate(element.start_date.split('T')[0]));
            }
            let agentVal = getNameByRecord(element.name, element);
            let vehicleVal = element.vehicle_number ?? element.vechicle_no ?? '';
            let refundAmount = roundNumber((element.amount_paid || 0) - (element.cancellation_penalty || 0));
            let row = [
                element.pnr,
                agentVal,
                bookingTime,
                element.seat_number ?? '',
                getSeatCountForExport(element),
                element.full_name ?? '',
                element.phone_number ?? '',
                element.traveller_status ?? '',
                element.origin ?? '',
                element.destination ?? '',
                vehicleVal,
                roundNumber(element.fare),
                roundNumber(AFP(element.cgst || 0, element.sgst || 0)),
                roundNumber(element.ticket_cost),
                roundNumber(element.cancellation_penalty),
                refundAmount,
                startDate,
                element.description ?? '',
                element.customer_gst_number ?? ''
            ];
            if(onlyForMaven()){
                let deductedAmount = 0;
                if (isDateInRange(getAPIDateFormat(getCurrentDateInIST(element.booking_time)), getAPIDateFormat(decrementDays(filters.dateRange?.[0] || new Date(),1)), getAPIDateFormat(incrementDays(filters.dateRange?.[1] || new Date(),1)))) {
                    deductedAmount = (element.cancellation_penalty*75)/100;
                } else {
                    let agentPenality = getValueFromPercentage(element.cancellation_penalty, element.cancellation_penality_percentage);
                    deductedAmount = (element.cancellation_penalty+element.commission-agentPenality-element.discounted_fare);
                }
                row.push(roundNumber(deductedAmount));
            }
            reportsCancelledXmlData.push(row);
        });
    }

    if(isValidArray(confirmedDiscountedTickets)&&confirmedDiscountedTickets.length>0){
        confirmedDiscountedTickets.forEach(element => {
            let startDate = '';
            let bookingTime = isValid(element.booking_time) ? getLocalDate(convertDateStringToDate(element.booking_time.split('T')[0])) : '';
            if(isValid(element.start_date)){
                startDate = getLocalDate(convertDateStringToDate(element.start_date.split('T')[0]));
            }
            let agentVal = getNameByRecord(element.name, element);
            reportDiscountXmlData.push([
                element.pnr, element.full_name ?? '', element.phone_number ?? '', element.seat_number ?? '',
                getSeatCountForExport(element),
                agentVal,
                element.fare, element.discounted_fare, element.commission,
                roundNumber((element.amount_paid || 0) - (element.commission || 0)),
                element.description ?? '', bookingTime, startDate
            ]);
        });
    }

    const discountHeaders = ["PNR","Name","Phone Number","Seat number","Seat count","Agent","Fare","Discounted Fare(A)","Commission","Net Amount Deducted","Trip description","Booking time","Travel date"];

    var worksheet = XLSX.utils.aoa_to_sheet([
        [], [],
        ["Report","Agents","From Date", "To Date","Type of date" , "Generated day/time"],
        ["Booked Tickets",agentName,filters.fromDate,filters.toDate,dateType,generatedTime],
        [], [],
        ["Confirmed Tickets"],
        confirmedHeaders,
        ...reportsConfirmedXmlData,
        [], [],
        ["Cancelled Tickets"],
        cancelledHeaders,
        ...reportsCancelledXmlData,
        [], [],
        ["Exceptional discount"],
        discountHeaders,
        ...reportDiscountXmlData
    ]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Booked Seats Report');
    XLSX.writeFile(workbook, 'booked-tickets-report.xlsx');
}


const getFilterOptions=(data)=>{
    let key = 'name';
    if(verifyOTAOrDafidyUser()){
        key = 'operator_name';
    }

    if(isValidArray(data)&&data.length>0){
        let filterOptions=[],insertedEntries=[];
        for (let index = 0; index < data.length; index++) {
            const element = data[index];
            if(insertedEntries.indexOf(element[key]) == -1){
                insertedEntries.push(element[key]);
                filterOptions.push({
                    text:element[key],
                    value:element[key]
                })
            }
        }
        return filterOptions;
    }else{
        return []
    }
}



const { Text } =Typography;

const { RangePicker } = DatePicker;

let allowedMaxDaysRange=31;
let xs=24, sm=24, md=12 , lg=12 , xl=12 , xxl=12;

const RenderReport=({cancelledTickets,confirmedTickets,confirmedDiscountedTickets,formValues,confirmedTicketSummary,cancelledTicketSummary,pagination})=>{

    let {
        dateRange,
        isBooking
    }=formValues;

    const [cancelledPage, setCancelledPage] = useState(1);
    const [confirmedPage, setConfirmedPage] = useState(1);
    const [cancelPaginationSize, setCancelPaginationSize] = useState(getDefaultPageSize);
    const [confirmPaginationSize, setConfirmPaginationSize] = useState(getDefaultPageSize);

    const cancelTicketColumns = [
        {
            title:"SN",
            key:"index",
            render : (text, record, index) => (cancelledPage - 1) * cancelPaginationSize + index+1
        },
        {
            title:"PNR",
            key:"pnr",
            dataIndex:'pnr',
            render:(text,record,index)=>text
        },
        {
            title:"Agent",
            key:"name",
            dataIndex:"name",
            filters:getFilterOptions(cancelledTickets),
            onFilter: (value, record) => {
                let key = 'name';
                if(verifyOTAOrDafidyUser()){
                    key = 'operator_name';
                }
                return record[key].indexOf(value) === 0;
            },
            render:(text,record)=>(getNameByRecord(text,record))
        },
        {
            title:"Booking time",
            key:"booking_time",
            render : (text, record, index) => isValid(record.booking_time) ? getLocalDateAndTime(record.booking_time) : ''
        },
        {
            title:"Seat number",
            key:"seat_number",
            dataIndex:"seat_number",
            render:(text,record,index)=>text
        },
        {
            title:"Seat count",
            key:"seat_numbers_comma",
            render:(text,record,index)=> isValid(record.seat_number) ? String(record.seat_number).split(/[;,]/).filter(Boolean).length : ''
        },
        {
            title:"Name",
            key:"full_name",
            dataIndex:"full_name",
            render:(text,record,index)=>text
        },
        {
            title:"Phone Number",
            key:"phone_number",
            dataIndex:"phone_number",
            render:(text,record,index)=>text
        },
        {
            title:"Status",
            key:"traveller_status",
            dataIndex:"traveller_status",
            render:(text,record,index)=> record.traveller_status ?? ''
        },
        {
            title:"Origin",
            key:"origin",
            dataIndex:"origin",
            render:(text,record,index)=> record.origin ?? ''
        },
        {
            title:"Destination",
            key:"destination",
            dataIndex:"destination",
            render:(text,record,index)=> record.destination ?? ''
        },
        {
            title:"Vehicle Number",
            key:"vehicle_number",
            dataIndex:"vehicle_number",
            render:(text,record,index)=> record.vehicle_number ?? record.vechicle_no ?? ''
        },
        {
            title:"Ticket Fare(A)",
            key:"fare",
            dataIndex:"fare",
            render:(text,record,index)=> roundNumber(text)
        },
        {
            title:"GST(B)",
            key:"gst",
            render : (text, record, index) => roundNumber(AFP(record.cgst || 0, record.sgst || 0))
        },
        {
            title:"Total amount",
            key:"ticket_cost",
            dataIndex:"ticket_cost",
            render:(text,record,index)=> roundNumber(text)
        },
        {
            title:"Penality",
            key:"cancellation_penalty",
            dataIndex:"cancellation_penalty",
            render:(text,record,index)=> roundNumber(text)
        },
        {
            title:"Refund amount",
            key:"refund_amount",
            render: (text, record) => roundNumber((record.amount_paid || 0) - (record.cancellation_penalty || 0))
        },
        {
            title:"Travel date",
            key:"start_date",
            render : (text, record, index) => {
                if(isValid(record.start_date)){
                    return getLocalDate(convertDateStringToDate(record.start_date.split('T')[0]));
                }
                return '';
            }
        },
        {
            title:"Trip description",
            key:"description",
            dataIndex:"description",
            render:(text,record,index)=> text ?? ''
        },
        {
            title:"Cust GST Number",
            key:"customer_gst_number",
            dataIndex:"customer_gst_number",
            render:(text,record,index)=> record.customer_gst_number ?? ''
        }
    ];
    if(onlyForMaven()){
        cancelTicketColumns.push({
            title:"Net Amount Deducted",
            key:"net_deducted",
            render : (text, record, index) => {
                let deductedAmount = 0;
                if (isDateInRange(getAPIDateFormat(getCurrentDateInIST(record.booking_time)), getAPIDateFormat(decrementDays(dateRange[0],1)), getAPIDateFormat(incrementDays(dateRange[1],1)))) {
                    deductedAmount = (record.cancellation_penalty*75)/100;
                } else {
                    let agentPenality = getValueFromPercentage(record.cancellation_penalty,record.cancellation_penality_percentage);
                    deductedAmount = (record.cancellation_penalty+record.commission-agentPenality-record.discounted_fare);
                }
                return roundNumber(deductedAmount);
            }
        });
    }

    const confirmedTicketColumns=[
        {
            title:"SN",
            key:"index",
            render : (text, record, index) => (confirmedPage - 1) * confirmPaginationSize + index+1
        },
        {
            title:"PNR",
            key:"pnr",
            dataIndex:'pnr',
            render:(text,record)=>{
                if(record.traveller_status == "Rescheduled"){
                    return(
                        <Tooltip title={`Rescheduled to ${record.original_pnr}`}>
                            <span style={{marginRight:5}}>
                                {text}
                            </span>
                            <InfoCircleOutlined />
                        </Tooltip>
                    )
                }else{
                    if(isValid(record.rescheduled_pnr)&&record.traveller_status == "Confirmed"){
                        return (
                            <Tooltip title={`Rescheduled from ${record.rescheduled_pnr}`}>
                                <span style={{marginRight:5}}>
                                    {text}
                                </span>
                                <InfoCircleOutlined />
                            </Tooltip>
                        );
                    }else{
                        return text;
                    }
                }
            }
        },
        {
            title:"Agent",
            key:"name",
            dataIndex:"name",
            filters:getFilterOptions(confirmedTickets),
            onFilter: (value, record) => {
                let key = 'name';
                if(verifyOTAOrDafidyUser()){
                    key = 'operator_name';
                }
                return record[key].indexOf(value) === 0;
            },
            render:(text,record)=>(getNameByRecord(text,record))
        },
        {
            title:"Booking time",
            key:"booking_time",
            render : (text, record, index) => isValid(record.booking_time) ? getLocalDateAndTime(record.booking_time) : ''
        },
        {
            title:"Seat number",
            key:"seat_number",
            dataIndex:"seat_number",
            render:(text,record,index)=>text
        },
        {
            title:"Seat count",
            key:"seat_numbers_comma",
            render:(text,record,index)=> isValid(record.seat_number) ? String(record.seat_number).split(/[;,]/).filter(Boolean).length : ''
        },
        {
            title:"Name",
            key:"full_name",
            dataIndex:"full_name",
            render:(text,record,index)=>text
        },
        {
            title:"Phone Number",
            key:"phone_number",
            dataIndex:"phone_number",
            render:(text,record,index)=>text
        },
        {
            title:"Status",
            key:"traveller_status",
            dataIndex:"traveller_status",
            render:(text,record,index)=> record.traveller_status || ''
        },
        {
            title:"Origin",
            key:"origin",
            dataIndex:"origin",
            render:(text,record,index)=> record.origin ?? ''
        },
        {
            title:"Destination",
            key:"destination",
            dataIndex:"destination",
            render:(text,record,index)=> record.destination ?? ''
        },
        {
            title:"Vehicle Number",
            key:"vehicle_number",
            dataIndex:"vehicle_number",
            render:(text,record,index)=> record.vehicle_number ?? record.vechicle_no ?? ''
        },
        {
            title:"Ticket Fare(A)",
            key:"fare",
            dataIndex:"fare",
            render : (text, record, index) => {
                if(record.traveller_status == "Confirmed"){
                    return roundNumber(text);
                }
                return null;
            }
        },
        {
            title:"GST(B)",
            key:"gst",
            render : (text, record, index) => {
                if(record.traveller_status == "Confirmed"){
                    return roundNumber(AFP(record.cgst || 0, record.sgst || 0));
                }
                return null;
            }
        },
        {
            title:"Total amount",
            key:"ticket_cost",
            dataIndex:"ticket_cost",
            render : (text, record, index) => {
                if(record.traveller_status == "Confirmed"){
                    return roundNumber(text);
                }
                return null;
            }
        },
        {
            title:"Discount(D)",
            key:"direct_discount",
            dataIndex:"direct_discount",
            render : (text, record, index) => {
                if(record.traveller_status == "Confirmed"){
                    return roundNumber(text ?? 0);
                }
                return null;
            }
        },
        {
            title:"Amount Paid(A+B-D)",
            key:"amount_paid_display",
            render : (text, record, index) => {
                if(record.traveller_status == "Confirmed"){
                    return roundNumber(record.amount_paid ?? 0);
                }
                return null;
            }
        },
        {
            title:"Commission(F)",
            key:"commission",
            dataIndex:"commission",
            render : (text, record, index) => {
                if(record.traveller_status == "Confirmed"){
                    return roundNumber(text);
                }
                return null;
            }
        },
        {
            title:"TDS(G)",
            key:"tds_on_commission",
            dataIndex : "tds_on_commission",
            render : (text, record, index) => {
                if(record.traveller_status == "Confirmed"){
                    return roundNumber(text);
                }
                return null;
            }
        },
        {
            title:"Net commission(F-G)",
            key:"net_commission",
            dataIndex:"net_commission",
            render : (text, record, index) => {
                if(record.traveller_status == "Confirmed"){
                    return roundNumber(text);
                }
                return null;
            }
        },
        {
            title:"Net amount",
            key:"net_amount",
            render : (text, record, index) => {
                if(record.traveller_status == "Confirmed"){
                    return roundNumber(AFP(SFP(record.amount_paid, record.net_commission || 0), 0));
                }
                return null;
            }
        },
        {
            title:"Travel date",
            key:"start_date",
            render : (text, record, index) => {
                if(isValid(record.start_date)){
                    return getLocalDate(convertDateStringToDate(record.start_date.split('T')[0]));
                }
                return '';
            }
        },
        {
            title:"Trip description",
            key:"description",
            dataIndex:"description",
            render:(text,record,index)=> text ?? ''
        },
        {
            title:"Cust GST Number",
            key:"customer_gst_number",
            dataIndex:"customer_gst_number",
            render:(text,record,index)=> record.customer_gst_number ?? ''
        }
    ];
    if(onlyForMaven()){
        confirmedTicketColumns.push({
            title:"Net Amount Deducted (A-B)",
            key:"net_amount_deducted_maven",
            render:(text,record)=>{
                if(record.traveller_status == "Confirmed"){
                    return roundNumber(record.discounted_fare - (record.commission || 0));
                }
                return null;
            }
        });
        const mavenKeysToRemove = ['tds_on_commission', 'net_commission', 'net_amount'];
        for (let i = confirmedTicketColumns.length - 1; i >= 0; i--) {
            if (mavenKeysToRemove.includes(confirmedTicketColumns[i].key)) {
                confirmedTicketColumns.splice(i, 1);
            }
        }
    }
    confirmedTicketColumns.push({
        title:"Rescheduled",
        key:"rescheduled",
        render : (text, record, index) => record.traveller_status == "Rescheduled" ? "Yes" : "No"
    });

    if((isValidArray(cancelledTickets)||isValidArray(confirmedTickets))&&isValidArray(dateRange)){
        return(
            <div className="booked-tickets-report">
                <Row justify="center">
                    <Col>
                        <Text strong className="report-title">Booked Tickets</Text>
                    </Col>
                </Row>
                <Row justify="space-between">
                    <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                        <Text>
                            <Text strong>From Date : </Text>
                            {getAPIDateFormat(dateRange[0])}
                        </Text>
                    </Col>
                    <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                        <Text>
                            <Text strong>To Date : </Text>
                            {getAPIDateFormat(dateRange[1])}
                        </Text>
                    </Col>
                </Row>
                <Row justify="space-between">
                    <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                        <Text>
                            <Text strong>Agent Privilege : </Text>
                            {global.privilege}
                        </Text>
                    </Col>
                    <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                        <Text>
                            <Text strong>Generated day/time : </Text>{ getLocalDateAndTime(new Date())}
                        </Text> 
                    </Col>
                </Row>
                {isBooking!="cancel"&&<Row gutter={[16,16]}>
                        <Col>
                            <Text strong>Confirmed tickets</Text>
                        </Col>
                </Row>}
                {isBooking!="cancel"&&isValid(confirmedTicketSummary)&&
                <Row justify="space-between">
                    <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                        <Text>
                            <Text strong>Total Fare : </Text>
                            {roundNumber(confirmedTicketSummary.summaryFare)}
                        </Text>
                    </Col>
                    <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                        <Text>
                            <Text strong>Total Commission : </Text>{roundNumber(confirmedTicketSummary.summaryTotalComm)}
                        </Text>
                    </Col>
                    {!verifyOTAOrDafidyUser() && 
                    <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                        <Text>
                            <Text strong>Total TDS : </Text>{roundNumber(confirmedTicketSummary.summaryTds)}
                        </Text>
                    </Col>
                    }
                    {!verifyOTAOrDafidyUser() && 
                    <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                        <Text>
                            <Text strong>Total Net Commission : </Text>{roundNumber(confirmedTicketSummary.summaryNetComm)}
                        </Text>
                    </Col>
                    }
                    
                </Row>
                }
                {isBooking!="cancel"&&<Row gutter={[16,16]} className="marginTop">
                    <Col>
                        <Table 
                            className="bordered-table report-table"
                            columns={confirmedTicketColumns}
                            dataSource={confirmedTickets}
                            pagination={getPaginationDetails(pagination, setConfirmedPage, confirmPaginationSize, setConfirmPaginationSize)}
                            summary={(pageData ) => {
                                let summaryFare = 0;
                                let summaryGst = 0;
                                let summaryTicketCost = 0;
                                let summaryDiscount = 0;
                                let summaryAmountPaid = 0;
                                let summaryTotalComm = 0;
                                let summaryTds = 0;
                                let summaryNetComm = 0;
                                let summaryNetAmount = 0;
                                pageData.forEach((row) => {
                                  if (row.traveller_status !== "Confirmed") return;
                                  if(isValidNumber(row.fare)) summaryFare += row.fare;
                                  summaryGst += AFP(row.cgst || 0, row.sgst || 0);
                                  if(isValidNumber(row.ticket_cost)) summaryTicketCost += row.ticket_cost;
                                  if(isValidNumber(row.amount_paid)) summaryAmountPaid += row.amount_paid;
                                  summaryDiscount += row.direct_discount ?? 0;
                                  if(isValidNumber(row.commission)) summaryTotalComm += row.commission;
                                  if(isValidNumber(row.tds_on_commission)) summaryTds += row.tds_on_commission;
                                  if(isValidNumber(row.net_commission)) summaryNetComm += row.net_commission;
                                  summaryNetAmount += AFP(SFP(row.amount_paid || 0, row.net_commission || 0), 0);
                                });
                                const cells = [
                                    <Table.Summary.Cell key="total" style={{ fontWeight: 'bold' }}>Total:</Table.Summary.Cell>,
                                    ...Array(11).fill(null).map((_, i) => <Table.Summary.Cell key={`e${i}`}></Table.Summary.Cell>),
                                    <Table.Summary.Cell key="fare" style={{ textAlign: 'right', fontWeight: 'bold' }}>{roundNumber(summaryFare)}</Table.Summary.Cell>,
                                    <Table.Summary.Cell key="gst" style={{ textAlign: 'right', fontWeight: 'bold' }}>{roundNumber(summaryGst)}</Table.Summary.Cell>,
                                    <Table.Summary.Cell key="totalAmt" style={{ textAlign: 'right', fontWeight: 'bold' }}>{roundNumber(summaryTicketCost)}</Table.Summary.Cell>,
                                    <Table.Summary.Cell key="disc" style={{ textAlign: 'right', fontWeight: 'bold' }}>{roundNumber(summaryDiscount)}</Table.Summary.Cell>,
                                    <Table.Summary.Cell key="amtPaid" style={{ textAlign: 'right', fontWeight: 'bold' }}>{roundNumber(summaryAmountPaid)}</Table.Summary.Cell>,
                                    <Table.Summary.Cell key="comm" style={{ textAlign: 'right', fontWeight: 'bold' }}>{roundNumber(summaryTotalComm)}</Table.Summary.Cell>,
                                    ...(!onlyForMaven() ? [<Table.Summary.Cell key="tds" style={{ textAlign: 'right', fontWeight: 'bold' }}>{roundNumber(summaryTds)}</Table.Summary.Cell>] : []),
                                    ...(!onlyForMaven() ? [<Table.Summary.Cell key="netComm" style={{ textAlign: 'right', fontWeight: 'bold' }}>{roundNumber(summaryNetComm)}</Table.Summary.Cell>] : []),
                                    <Table.Summary.Cell key="netAmt" style={{ textAlign: 'right', fontWeight: 'bold' }}>{roundNumber(summaryNetAmount)}</Table.Summary.Cell>,
                                    ...Array(4).fill(null).map((_, i) => <Table.Summary.Cell key={`e2-${i}`}></Table.Summary.Cell>),
                                      ...(onlyForMaven() ? [<Table.Summary.Cell key="maven" style={{ textAlign: 'right', fontWeight: 'bold' }}>{roundNumber(summaryFare - summaryTotalComm)}</Table.Summary.Cell>] : [])
                                ];
                                return (
                                    <Table.Summary fixed>
                                    <Table.Summary.Row style={{ backgroundColor: '#f0f2f5', fontWeight: 'bold', borderTop: '1px solid #d9d9d9' }}>
                                      {cells}
                                    </Table.Summary.Row>
                                  </Table.Summary>
                                );
                            }}
                        />
                    </Col>
                </Row>}
                <Row gutter={[16,16]}>
                        <Col>
                            <Text strong>Cancelled tickets</Text>
                        </Col>
                </Row>
                {isValid(cancelledTicketSummary)&&<>
                <Row justify="space-between">
                    <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                        <Text>
                            <Text strong>{verifyOTAOrDafidyUser()?"Total Fare":"Total Amount"} : </Text>
                            {roundNumber(verifyOTAOrDafidyUser()?cancelledTicketSummary.fareSummary: cancelledTicketSummary.summaryTicketCost)}
                        </Text>
                    </Col>
                    <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                        <Text>
                            <Text strong>Cancel Penalty : </Text>{roundNumber(cancelledTicketSummary.summaryCancellationPenality)}
                        </Text>
                    </Col>
                    <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                        <Text>
                            <Text strong>Refund : </Text>{roundNumber(cancelledTicketSummary.summaryOfRefund)}
                        </Text>
                    </Col>
                    {onlyForMaven() && 
                    <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
                        <Text>
                            <Text strong>Net Amount Deducted : </Text>{roundNumber(cancelledTicketSummary.cancellationPenalitySummary)}
                        </Text>
                    </Col>
                    }
                </Row>
                </>}
                <Row gutter={[16,16]} className="marginTop">
                    <Col>
                        <Table
                            className="bordered-table report-table"
                            columns={cancelTicketColumns}
                            dataSource={cancelledTickets}
                            pagination={getPaginationDetails(pagination, setCancelledPage, cancelPaginationSize, setCancelPaginationSize)}
                            summary={(pageData ) => {
                                let fareSummary = 0;
                                let summaryGst = 0;
                                let summaryTicketCost = 0;
                                let summaryCancellationPenality = 0;
                                let summaryOfRefund = 0;
                                let cancellationPenalitySummary = 0;
                                pageData.forEach((row) => {
                                  if(isValidNumber(row.ticket_cost)) summaryTicketCost += row.ticket_cost;
                                  if(isValidNumber(row.fare)) fareSummary += row.fare;
                                  summaryGst += AFP(row.cgst || 0, row.sgst || 0);
                                  if(isValidNumber(row.cancellation_penalty)){
                                    summaryCancellationPenality += row.cancellation_penalty;
                                    summaryOfRefund += (row.amount_paid || 0) - row.cancellation_penalty;
                                  }
                                  if(onlyForMaven()){
                                    if (isDateInRange(getAPIDateFormat(getCurrentDateInIST(row.booking_time)), getAPIDateFormat(decrementDays(dateRange[0],1)), getAPIDateFormat(incrementDays(dateRange[1],1)))) {
                                        cancellationPenalitySummary += (row.cancellation_penalty || 0) * 75 / 100;
                                    } else {
                                        let agentPenality = getValueFromPercentage(row.cancellation_penalty, row.cancellation_penality_percentage);
                                        cancellationPenalitySummary += (row.cancellation_penalty || 0) + (row.commission || 0) - agentPenality - (row.discounted_fare || 0);
                                    }
                                  }
                                });
                                const cSummaryCell = (val, k) => <Table.Summary.Cell key={k} style={{ textAlign: 'right', fontWeight: 'bold' }}>{roundNumber(val)}</Table.Summary.Cell>;
                                const cEmpty = (i) => <Table.Summary.Cell key={`c${i}`}></Table.Summary.Cell>;
                                const cCells = [
                                    <Table.Summary.Cell key="ctotal" style={{ fontWeight: 'bold' }}>Total:</Table.Summary.Cell>,
                                    ...Array(11).fill(null).map((_, i) => cEmpty(i)),
                                    cSummaryCell(fareSummary, 'cdisc'),
                                    cSummaryCell(summaryGst, 'cgst'),
                                    cSummaryCell(summaryTicketCost, 'ctot'),
                                    cSummaryCell(summaryCancellationPenality, 'cpen'),
                                    cSummaryCell(summaryOfRefund, 'cref'),
                                    cEmpty(17), cEmpty(18), cEmpty(19),
                                    ...(onlyForMaven() ? [cSummaryCell(cancellationPenalitySummary, 'cmaven')] : [])
                                ];
                                return (
                                    <Table.Summary fixed>
                                    <Table.Summary.Row style={{ backgroundColor: '#f0f2f5', fontWeight: 'bold', borderTop: '1px solid #d9d9d9' }}>
                                      {cCells}
                                    </Table.Summary.Row>
                                  </Table.Summary>
                                );
                            }}
                          />
                    </Col>
                </Row>
                {isValidArray(confirmedDiscountedTickets)&&confirmedDiscountedTickets.length>0?
                    <div>
                         <Row gutter={[16,16]} className="marginTop">
                                <Col>
                                    <Text strong>Exceptional discount</Text>
                                </Col>
                        </Row>
                        <Row gutter={[16,16]} className="marginTop">
                            <Col>
                                <Table 
                                    className="bordered-table report-table"
                                    columns={getColsForDiscountedTickets(confirmedTicketColumns)}
                                    dataSource={confirmedDiscountedTickets}
                                    pagination={getPaginationDetails(pagination, setConfirmedPage, confirmPaginationSize, setConfirmPaginationSize)}
                                    summary={(pageData ) => {
                                        let summaryTotalAmount = 0;
                                        let summaryTotalComm = 0;
                                        let summaryQwikBusComm = 0;
                                        let netAmountDebited = 0;
                                        let summaryDiscountedFare = 0;
                                        pageData.forEach(({ fare , commission,comm_for_qwikbus,discounted_fare }) => {
                                        if(isValidNumber(fare)){
                                            summaryTotalAmount = summaryTotalAmount + fare;
                                            netAmountDebited = netAmountDebited+discounted_fare-commission;
                                        }
                                        if(isValidNumber(commission)){
                                            summaryTotalComm = summaryTotalComm + commission;
                                        }
                                        if(isValid(comm_for_qwikbus)){
                                            summaryQwikBusComm = comm_for_qwikbus + summaryQwikBusComm;
                                        }
                                        if(isValid(discounted_fare)){
                                            summaryDiscountedFare = summaryDiscountedFare + discounted_fare;
                                        }
                                        });
                                                                                                
                                        return(
                                            <Table.Summary fixed>
                                            <Table.Summary.Row style={{ backgroundColor: '#f0f2f5', fontWeight: 'bold', borderTop: '1px solid #d9d9d9' }}>
                                            <Table.Summary.Cell style={{ textAlign: 'right', fontWeight: 'bold' }}>Total:</Table.Summary.Cell>
                                            <Table.Summary.Cell></Table.Summary.Cell>
                                            <Table.Summary.Cell></Table.Summary.Cell>
                                            <Table.Summary.Cell></Table.Summary.Cell>
                                            <Table.Summary.Cell></Table.Summary.Cell>
                                            <Table.Summary.Cell></Table.Summary.Cell>
                                            <Table.Summary.Cell style={{ textAlign: 'right', fontWeight: 'bold' }}>{roundNumber(summaryTotalAmount)}</Table.Summary.Cell>
                                            <Table.Summary.Cell style={{ textAlign: 'right', fontWeight: 'bold' }}>{roundNumber(summaryDiscountedFare)}</Table.Summary.Cell>
                                            <Table.Summary.Cell style={{ textAlign: 'right', fontWeight: 'bold' }}>{roundNumber(summaryTotalComm)}</Table.Summary.Cell>
                                            {onlyForMaven()&&
                                                <Table.Summary.Cell style={{ textAlign: 'right', fontWeight: 'bold' }}>{roundNumber(netAmountDebited)}</Table.Summary.Cell>
                                            }
                                            <Table.Summary.Cell></Table.Summary.Cell>
                                            <Table.Summary.Cell></Table.Summary.Cell>
                                            <Table.Summary.Cell></Table.Summary.Cell>
                                            </Table.Summary.Row>
                                            </Table.Summary>
                                        )
                                    }}
                                />
                            </Col>
                        </Row>
                    </div>
                :
                    null
                }
            </div>
        )
    }else{
        return null
    }
}

export const BookedTicketsReport = () => {


    const [cancelledTickets,setCancelledTickets]=useState([]);
    const [confirmedTickets,setConfirmedTickets]=useState([]);
    const [confirmedDiscountedTickets,setConfirmedDiscountedTickets]=useState([]);
    const [confirmedTicketSummary, setConfirmedTicketSummary] = useState({});
    const [cancelledTicketSummary, setCancelledTicketSummary] = useState({})

    const [showReport,setShowReport]=useState(false);

    const dispatch=useDispatch();

    const onSuccess=(data)=>{
        let {
            cancelledTransactions,
            confirmedTransactions
        }= data;
        setLoading(false);
        setShowReport(true);
        let {
            confirmData,discountData, confirmedSummaryData
        } = getConfirmData(confirmedTransactions);
        setConfirmedTickets(confirmData);
        setConfirmedDiscountedTickets(discountData);
        setCancelledTickets(cancelledTransactions);
        setConfirmedTicketSummary(confirmedSummaryData);
        setCancelledTicketSummary(getCancelledTicketSummary(cancelledTransactions, form.getFieldsValue().dateRange));
    }

    const onFailure=()=>{
        setLoading(false);
    }

    const setLoading=(bool)=>{
        dispatch(loadingAction(bool));
    }

    const onFinish=(values)=>{
        let {
            dateRange,
            isBooking
        }=values;
        setShowReport(false);
        const fromDate = getAPIDateFormat(dateRange[0]);
        const toDate = getAPIDateFormat(dateRange[1]);
        setLoading(true);
        fetchBookingSheet(fromDate,toDate,isBooking,onSuccess,onFailure);
    }

    const [form] = Form.useForm();
    
    return (
            <div className="report-inner-div">
                <Form
                onFinish={onFinish}
                form={form}
                >
                    <Row gutter={[16,16]}>
                        <Col>
                            <Form.Item name="dateRange" label="Date range" 
                                rules={[
                                    { required: true , message: 'Please input your date range!'},
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                        if (!value || (value[1].diff(value[0],"days") <= allowedMaxDaysRange)) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error(`Please select a date range with in ${allowedMaxDaysRange} days`));
                                        },
                                    })
                                ]}>
                                    <RangePicker 
                                        ranges={getRangeOptions(allowedMaxDaysRange)} 
                                    />
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item name="isBooking" label="" rules={[{ required: true , message: 'Please select any option!'}]}>
                                <Radio.Group>
                                    <Radio value={'book'}>Booking Date</Radio>
                                    <Radio value={'travel'}>Travel Date</Radio>
                                    <Radio value={'cancel'}>Cancellation Date</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item>
                                <Button htmlType="submit">Search</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                {showReport?
                    <Row gutter={16}>
                        <Col>
                            <Button onClick={()=>{
                                generateJsonToExport(form,confirmedTickets,cancelledTickets,confirmedDiscountedTickets);
                            }}>Export</Button>
                        </Col>
                        <Col>
                            <Printer 
                                showComponent={false}
                                renderComponent={()=>{
                                    return (
                                        <RenderReport 
                                            cancelledTickets={cancelledTickets}
                                            confirmedTickets={confirmedTickets}
                                            confirmedDiscountedTickets={confirmedDiscountedTickets}
                                            formValues={form.getFieldsValue()}
                                            confirmedTicketSummary = {confirmedTicketSummary}
                                            cancelledTicketSummary = {cancelledTicketSummary}
                                            pagination={false}
                                        />
                                    )
                                }} 
                                zoomValue={0.5}
                                />
                        </Col>
                    </Row>
                    :
                    null
                }
                <RenderReport 
                    cancelledTickets={cancelledTickets}
                    confirmedTickets={confirmedTickets}
                    confirmedDiscountedTickets={confirmedDiscountedTickets}
                    formValues={form.getFieldsValue()}
                    confirmedTicketSummary = {confirmedTicketSummary}
                    cancelledTicketSummary = {cancelledTicketSummary}
                    pagination={true}
                 />
            </div>
    )
}